export const SET_APP_NOTIFICATION_DATA = 'SET_APP_NOTIFICATION_DATA'
export const SET_APP_STATUS = 'SET_APP_STATUS'
